import React, {useEffect, useState} from "react";
import Loading from "../../components/Loading/Loading";
import useProfileBoostService from "../../api/services/useProfileBoostService";
import Button from "../../components/Button/Button";
import ProfileBoostIcon from "../../assets/icons/profile-boost-white.svg"
import useFunction from "../../hooks/useFunction";
import StandIcon from "../../assets/icons/stand-white.svg"
import SpotGroupIcon from "../../assets/icons/spot-group-white.svg"
import CreditsIcon from "../../assets/icons/credits.svg"
import ProfileBoostWhiteIcon from "../../assets/icons/profile-boost.svg"
import SearchIcon from "../../assets/icons/search.svg"
import ShareIcon from "../../assets/icons/share.svg"
import StarIcon from "../../assets/icons/star.svg"
import CheckIcon from "../../assets/icons/check.svg"

const UserProfileBoosts = () => {

  const {userShowCollection} = useProfileBoostService()
  const [profileBoosts, setProfileBoosts] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const {dateTime, truncate} = useFunction()

  useEffect(() => {
    userShowCollection(
      (profileBoosts) => {
        setProfileBoosts(profileBoosts)
        setIsLoading(false)
      },
      (errors) => {
        setIsLoading(false)
      },
    )
  }, [])

  return (
    <div className="page-user-profile_boosts">
      {/* Hero Section */}
      <div className="boost-hero">
        <div className="boost-hero-content">
          <div className="boost-icon-large">
            <img src={ProfileBoostWhiteIcon} alt="Profile Boost" />
          </div>
          <h1>Boost je profiel</h1>
          <p className="boost-subtitle">
            Vergroot je zichtbaarheid en krijg meer boekingsaanvragen
          </p>
        </div>
      </div>

      {/* Benefits Section */}
      <div className="boost-benefits">
        <h2>Wat krijg je met een Profile Boost?</h2>
        <div className="benefits-grid">
          <div className="benefit-card">
            <div className="benefit-icon">
              <img src={SearchIcon} alt="" />
            </div>
            <h3>Hogere ranking</h3>
            <p>Jouw profiel verschijnt <strong>bovenaan</strong> in de zoekresultaten op de homepagina</p>
          </div>
          <div className="benefit-card">
            <div className="benefit-icon">
              <img src={ShareIcon} alt="" />
            </div>
            <h3>Social media aandacht</h3>
            <p>Je profiel wordt uitgelicht op onze <strong>social media kanalen</strong> (Facebook, Instagram & LinkedIn)</p>
          </div>
          <div className="benefit-card">
            <div className="benefit-icon">
              <img src={StarIcon} alt="" />
            </div>
            <h3>Opvallende weergave</h3>
            <p>Je profiel krijgt een <strong>speciale markering</strong> waardoor bezoekers je sneller opmerken</p>
          </div>
        </div>
      </div>

      {/* Pricing Section */}
      <div className="boost-pricing">
        <div className="pricing-card">
          <div className="pricing-header">
            <span className="pricing-duration">1 week</span>
            <div className="pricing-amount">
              <span className="price">€10,-</span>
              <span className="price-note">excl. btw</span>
            </div>
          </div>
          <ul className="pricing-features">
            <li><img src={CheckIcon} alt="" /> 7 dagen bovenaan in zoekresultaten</li>
            <li><img src={CheckIcon} alt="" /> Promotie via social media</li>
            <li><img src={CheckIcon} alt="" /> Direct actief na betaling</li>
            <li>
              <img src={CreditsIcon} alt="" width={20} />
              Of betaal met <strong>1000 Stand credits</strong>
            </li>
          </ul>
          <Button
            label="Start Profile Boost"
            link="/wizard/boost"
            color="blue"
            icon={ProfileBoostIcon}
            size="l"
          />
        </div>
      </div>

      {/* Active Boosts Section */}
      <div className="boost-active-section">
        <h2>Jouw actieve boosts</h2>
        {isLoading
          ? <Loading/>
          : <div>
            {profileBoosts.length === 0 ?
              <div className="no-boosts">
                <p>Je hebt nog geen actieve boosts. Start vandaag nog en vergroot je bereik!</p>
              </div>
              :
              <div className="profile_boosts">
                {profileBoosts.map((profileBoost, i) => {
                  return (
                    <div className="row profile_boost" key={i}>
                      <div className="col is-active">
                        {(profileBoost.ongoing && profileBoost.is_paid)
                          ? <div className="active-badge">
                              <img src={ProfileBoostWhiteIcon} alt="Deze profiel boost is actief" width={32}/>
                              <span>Actief</span>
                            </div>
                          : <span className="inactive-badge">Niet actief</span>
                        }
                      </div>
                      <div className="col date">
                        <span className="date-label">Start</span>
                        <span className="date-value">{dateTime(profileBoost.start_at)}</span>
                      </div>
                      <div className="col date">
                        <span className="date-label">Einde</span>
                        <span className="date-value">{dateTime(profileBoost.end_at)}</span>
                      </div>
                      <div className="col button">
                        {profileBoost.stand &&
                          <Button
                            label={"Stand: " + truncate(profileBoost.stand.label, 12)}
                            size="s"
                            icon={StandIcon}
                          />
                        }
                        {profileBoost.spot_group &&
                          <Button
                            label={"Locatie: " + truncate(profileBoost.spot_group.label, 10)}
                            size="s"
                            icon={SpotGroupIcon}
                          />
                        }
                      </div>
                    </div>
                  )
                })}
              </div>
            }
          </div>
        }
      </div>
    </div>
  )
}

export default UserProfileBoosts
